module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changelog"
  }, [_c('h2', [_vm._v("Changelog")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, [_c('strong', [_vm._v("Version 1.4")]), _vm._v(" "), _c('p', [_vm._v("You can press your score to toggle between current level and score")]), _vm._v(" "), _c('p', [_vm._v("See who the most adicted player is, check the highscore")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-030d6c7f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Changelog.vue
// module id = 107
// module chunks = 1